import type { Skeleton } from './skeleton/core';
import type { MappingResult } from './recognize/config';

/**
 * Bone indices that have a role and/or appear on a chain.
 * `null` when there is no mapping — unassigned visibility/filtering should not run.
 */
export function buildAssignedBoneIndexSet(
  mapping: MappingResult | null,
  skeleton: Skeleton | null,
): Set<number> | null {
  if (!mapping) return null;
  if (!skeleton) return new Set<number>();
  const set = new Set<number>();
  for (const boneRef of Object.values(mapping.roleToBone)) {
    const idx = skeleton.resolveBoneRef(boneRef, { namespace: 'internal' });
    if (idx !== null) set.add(idx);
  }
  for (const chainRefs of Object.values(mapping.chains)) {
    for (const ref of chainRefs) {
      const idx = skeleton.resolveBoneRef(ref, { namespace: 'internal' });
      if (idx !== null) set.add(idx);
    }
  }
  return set;
}
